const inspectionProfile = {
  buttons: {
    backbtn: "Atrás",
    submit: "Enviar",
    upload: "Cargar",
    addFile: "Agregar Archivo"
  },
  backbtn: "Atrás",
  submit: "Enviar",
  newInspection: "Crear nueva Inspección",
  details: "Detalles de la Inspección",
  equipmentTag: "Asset Tag",
  client: "Cliente",
  equipType: "Tipo de Activo",
  company: "Compañía",
  createby: "Creado por",
  date: "Fecha de Creación",
  coupled: "In Board",
  free: "Out Board",
  preasureBar: "Presión (BAR)",
  preasurePsi: "Presión (PSI)",
  stuffingBox: "Cámara de sellado",
  temperature: "Temperatura",
  pressure: "Presión",
  celsius: "Temperatura (Celsius)",
  fahrenheit: "Temperatura (Fahrenheit)",
  coolingWaterIn: "Entrada de enfriamiento de agua",
  coolingWaterOut: "Salida de enfriamento de agua",
  pumpHousing: "Carcasa de Bomba",
  oilIn: "Entrada de Aceite",
  ollOut: "Salida de Aceite",
  level: "Nivel",
  levelmm: "Nivel (mm)",
  levelL: "Nivel (l)",
  refilling: "Sistema de recarga",
  system: "Sistema",
  instrument: "Instrumento de viento",
  tank: "Tanque",
  cw: "Agua de enfriamiento",
  cin: "Entrada del In Board",
  cout: "Salida del In Board",
  fin: "Entrada del Out Board",
  fout: "Salida del Out Board",
  motor: "Motor",
  barrier: "Flujo de barrera",
  barrierFlowLmin: "Flujo de barrera (L/min)",
  Comment: "Comentario",
  barrierFlowGalmin: "Flujo de barrera (L/min)",
  delete: "Eliminar Inspección",
  inspectionSummary: "Resumen de inspección",
  PerfomedBy: "Elaborada por",
  createdBy: "Creada por",
  generalStatus: "Estatus general",
  alarmZone: "Zona de alarma",
  warningZone: "Zona de advertencia",
  smoothZone: "Zona optima",
  update: "Actualizar",
  addMultimedia: "Agregar multimedia",
  multimediaDetails: "Detalles",
  multimediaHint:
    "Agregue detalles acerca del archivo que desea cargar para el perfil de inspección",
  multimediaMessage: "Todavía no hay archivo para cargar a esta inspección",
  summary: "Resumen",
  variables: "Variables",
  multimedia: "Multimedia",
  inspectionMultimedia: "Multimedia de inspección",
  fileInput: "Agregar Archivo",
  status: {
    smooth: "Optimo",
    warning: "Advertencia",
    alarm: "Alarma"
  }
};
export default inspectionProfile;
